import { CustomWidgetCollection, Question } from 'survey-core';
import { SurveyCreator } from 'survey-creator-react';
import { HBSQuestion } from './CustomizeClass2MedDevSurveyAction';

interface CustomWidgetProps {
  name: string;
  title: string;
  iconName: string;
  activatedByChangeHandler: () => void;
  htmlTemplate: string;
  afterRenderHandler: (question: HBSQuestion, el: HTMLElement) => void;
  widgetCopyName?: string;
  surveyCreator?: SurveyCreator;
}

/** The most basic template for a CustomWidget in SurveyJS */
const CustomWidget = ({
  name,
  title,
  iconName,
  activatedByChangeHandler,
  htmlTemplate,
  afterRenderHandler,
  surveyCreator
}: CustomWidgetProps) => {
  const widget = {
    name,
    title,
    iconName,
    widgetIsLoaded: () => true, // we do not require anything so we just return true.
    isFit: (question: Question) => question.getType() === name,
    activatedByChanged: () => {
      activatedByChangeHandler();
    },
    isDefaultRender: false,
    htmlTemplate,
    afterRender: (question: Question, el: HTMLElement) => {
      afterRenderHandler(question as HBSQuestion, el);
    },
    willUnmount: () => {}
  };

  if (!CustomWidgetCollection.Instance.getCustomWidgetByName(name)) {
    CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
  }

  if (surveyCreator && !surveyCreator.toolbox.getItemByName(name)) {
    surveyCreator.toolbox.addItem({
      name,
      title,
      iconName,
      json: { type: name },
      category: 'Custom Type',
      className: 'svd_custom_type',
      isCopied: false
    });
  }
};

export default CustomWidget;
